import { create } from "zustand";

// Whether Settings' nav is open as a sheet on a phone; the header's menu button opens it, choosing a tab closes it.
export const useSettingsNavStore = create<{ open: boolean; setOpen: (open: boolean) => void }>((set) => ({
  open: false,
  setOpen: (open) => set({ open })
}));
